import React, { useEffect, useState } from "react";
import API from "../services/api";
import Sidebar from "../components/Sidebar";
import { toast } from "react-toastify";

function Planner() {
  const [dashboard, setDashboard] = useState(null);

  const [tasks, setTasks] = useState([]);

  const [form, setForm] = useState({
    task_title: "",
    task_description: "",
    due_date: ""
  });

  useEffect(() => {
    fetchDashboard();
    fetchTasks();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await API.get("/dashboard/summary");
      setDashboard(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchTasks = async () => {
    try {
      const res = await API.get("/planner");
      setTasks(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const addTask = async () => {
    if (!form.task_title) {
      toast.error("Task title required");
      return;
    }

    try {
      await API.post("/planner/add", form);

      toast.success("Task added");

      setForm({
        task_title: "",
        task_description: "",
        due_date: ""
      });

      fetchTasks();
    } catch {
      toast.error("Failed to add task");
    }
  };

  const markCompleted = async (task) => {
    try {
      await API.put(`/planner/${task.id}`, {
        ...task,
        status: "completed"
      });

      toast.success("Task completed");
      fetchTasks();
    } catch {
      toast.error("Update failed");
    }
  };

  const deleteTask = async (id) => {
    try {
      await API.delete(`/planner/${id}`);
      toast.success("Task deleted");
      fetchTasks();
    } catch {
      toast.error("Delete failed");
    }
  };

  const progress =
    dashboard?.total_days > 0
      ? Math.round(
          (dashboard.current_day / dashboard.total_days) * 100
        )
      : 0;

  return (
    <div className="dashboard-layout">
      <Sidebar />

      <div className="main-content">
        <div className="container-fluid">

          {/* Photo Reminder */}
          <div className="card dashboard-card photo-card mb-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h5>📷 Daily Photo Reminder</h5>
                <p>
                  Capture a quick photo of your vermibed
                  to track daily progress.
                </p>
              </div>

              <button className="btn btn-success">
                Take Today's Photo
              </button>
            </div>
          </div>

          {/* Summary Cards */}
          <div className="row g-4 mb-4">
            <div className="col-md-4">
              <div className="card dashboard-card text-center">
                <h6>Current Day</h6>
                <h2>
                  {dashboard?.current_day || 0}/
                  {dashboard?.total_days || 60}
                </h2>
                <small>
                  {(dashboard?.total_days || 60) -
                    (dashboard?.current_day || 0)} days remaining
                </small>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card dashboard-card text-center">
                <h6>Current Phase</h6>

                <span className="badge bg-primary p-2">
                  {dashboard?.current_phase || "Not Started"}
                </span>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card dashboard-card text-center">
                <h6>Progress</h6>

                <div className="progress mb-2">
                  <div
                    className="progress-bar bg-success"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>

                <h4>{progress}%</h4>
              </div>
            </div>
          </div>

          {/* Add Task */}
          <div className="card dashboard-card mb-4">
            <h3>🗓 Planner Task Management</h3>

            <div className="row g-3 mt-2">
              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="Task title"
                  value={form.task_title}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      task_title: e.target.value
                    })
                  }
                />
              </div>

              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="Description"
                  value={form.task_description}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      task_description: e.target.value
                    })
                  }
                />
              </div>

              <div className="col-md-3">
                <input
                  type="date"
                  className="form-control"
                  value={form.due_date}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      due_date: e.target.value
                    })
                  }
                />
              </div>

              <div className="col-md-1">
                <button
                  className="btn btn-success w-100"
                  onClick={addTask}
                >
                  +
                </button>
              </div>
            </div>
          </div>

          {/* Task List */}
          <div className="row">
            {tasks.map((task) => (
              <div className="col-md-6 mb-4" key={task.id}>
                <div className="card dashboard-card task-card">
                  <div className="d-flex justify-content-between">
                    <div>
                      <h5>{task.task_title}</h5>

                      <p>{task.task_description}</p>

                      <small>
                        Due: {task.due_date || "No date"}
                      </small>
                    </div>

                    <span
                      className={`badge ${
                        task.status === "completed"
                          ? "bg-success"
                          : "bg-warning"
                      }`}
                    >
                      {task.status}
                    </span>
                  </div>

                  <div className="mt-3 d-flex gap-2">
                    {task.status !== "completed" && (
                      <button
                        className="btn btn-dark btn-sm"
                        onClick={() =>
                          markCompleted(task)
                        }
                      >
                        Mark Complete
                      </button>
                    )}

                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() =>
                        deleteTask(task.id)
                      }
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
}

export default Planner;